import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from '@/contexts/LanguageContext';
import Navbar from '@/components/Navbar';
import BrochureModal from '@/components/BrochureModal';
import HomePage from '@/pages/HomePage';
import PortfolioPage from '@/pages/PortfolioPage';
import ContactPage from '@/pages/ContactPage';
import AdminPage from '@/pages/AdminPage';
import { useLanguage } from '@/contexts/LanguageContext';
import { t } from '@/data/translations';

function Footer() {
  const { lang } = useLanguage();
  const f = t.footer[lang];
  return (
    <footer data-testid="site-footer" className="bg-obsidian border-t border-white/5 py-8 px-6 md:px-12">
      <div className="max-w-[1400px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-alpine-mist/25 font-sans tracking-wide">
          &copy; {new Date().getFullYear()} {f.copy}
        </p>
        <p className="text-xs text-alpine-mist/20 font-sans tracking-wide">{f.legal}</p>
      </div>
    </footer>
  );
}

function AppInner() {
  const [brochureOpen, setBrochureOpen] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';

  // Admin page has its own layout
  if (isAdmin) {
    return <AdminPage />;
  }

  return (
    <>
      <div className="noise-overlay" />
      <Navbar onBrochureClick={() => setBrochureOpen(true)} />
      <BrochureModal open={brochureOpen} onOpenChange={setBrochureOpen} />
      <Routes>
        <Route path="/" element={<HomePage onBrochureClick={() => setBrochureOpen(true)} />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppInner />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
